module.exports = __webpack_public_path__ + "static/media/press27.d8c5d6d8.jpg";